import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { BehaviorSubject, map, Observable, of } from 'rxjs';
import { LibraryObjectsSerive } from '../../services/library_objects.service';
import { MainHeaderComponent } from "../../components/shared/main-header/main-header.component";
import { DataTableComponent } from '../../components/shared/data-table/data-table.component';
import { Table } from 'primeng/table';
import { AttributeMenuComponent } from '../attribute-menu.component';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogEditAttributesComponent } from '../../components/shared/dialog-edit-attributes/dialog-edit-attributes.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { AttributesService } from '../../services/attributes.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UsersService } from '../../users/users.service';
@Component({
  selector: 'app-attribute-list',
  standalone: true,
  imports: [MainHeaderComponent, DataTableComponent, CommonModule, MatIconModule, MatButtonModule],
  templateUrl: './attribute-list.component.html',
  styleUrl: './attribute-list.component.scss'
})
export class AttributeListComponent {
  private attributeSubject = new BehaviorSubject<any[]>([]);
  attribute$ = this.attributeSubject.asObservable();
  selectedLabel = '';
  canDelete: boolean = false;
  selectedAttribute: string = ''
  selectedItems: any[] = []
  attributeTypeId!: number
  columns: any[] = [
    { field: 'name', header: 'Nombre', filter: true, orderby: true },
    { field: 'label', header: 'Nombre visible', filter: true, orderby: true },
  ]

  @ViewChild('dt') table!: Table;
  constructor(
    private http: HttpClient, private libraryObjectsService: LibraryObjectsSerive,
    private route: ActivatedRoute, public dialog: MatDialog, private cdr: ChangeDetectorRef, private attributeService: AttributesService, private _snackBar: MatSnackBar, private userService: UsersService) { }


  ngOnInit() {
    this.userService.loadUsersStore();
    this.checkUserRoles();
    this.route.paramMap.subscribe(params => {
      const attr = params.get('type');
      if (attr) {
        this.selectedAttribute = attr;
        this.route.queryParamMap.subscribe(query => {
          this.attributeTypeId = Number(query.get('id'));
          this.selectedLabel = query.get('label') || attr;
        });
        this.loadData(attr);
      }
    });
  }

  onSelectionChange(event: any) {
    console.log('event', event)
    this.selectedItems = event
  }

  onRowSelect(event: any) {
    console.log('evento', event)
  }

  checkUserRoles(): void {
    this.userService.getCurrentUserUid$().subscribe((uid) => {
      if (uid) {
        this.userService.users$.subscribe((users) => {
          const currentUser = users.find((user) => user.uid === uid);
          if (currentUser) {
            this.canDelete = currentUser.roles?.admin || currentUser.roles?.superadmin || false;
            console.log('Roles cargados:', currentUser.roles, 'Can Delete:', this.canDelete);
          } else {
            console.warn('Usuario no encontrado en la lista de usuarios.');
            this.canDelete = false;
          }
        });
      } else {
        console.error('No se pudo obtener el UID del usuario autenticado.');
        this.canDelete = false;
      }
    });
  }
  attirbute_type: any

  loadData(attr: string) {
    try {
      this.libraryObjectsService.getAttributesByType(attr).subscribe(data => {
        this.attirbute_type = data
        this.attributeSubject.next(data);

        if (data.length > 0) {
          this.generateColumns(data[0], attr);
        }
      });
    } catch (error) {
      console.error('Error loading data:', error);
    }
  }

  generateColumns(firstItem: any, attr: string) {
    this.columns = [
      { field: `library_attribute_id`, header: 'Id', filter: false, orderby: true },
      { field: 'name', header: 'Nombre', filter: true, orderby: true },
      { field: 'label', header: 'Etiqueta', filter: true, orderby: true },
      { field: 'created_at', header: 'Creación', filter: false, orderby: false },
    ]
  }


  openDialog(rowData?: any) {

    const dialogRef = this.dialog.open(DialogEditAttributesComponent, {
      width: '80vw',
      maxWidth: '800px',
      data: {
        mode: rowData ? 'edit' : 'create',
        attributeType: this.selectedAttribute,
        type: this.attributeTypeId,
        attributeLabel: this.selectedLabel,
        values: rowData || null
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'refresh') {
        this.loadData(this.selectedAttribute);
        this.cdr.detectChanges();

      }
    });
  }

  onDelete(items: any) {
    // console.log('Delete items:', items);
    // const idField = `library_${this.selectedAttribute}_id`;
    // const id = items.map((item: any) => item[idField]);
    // console.log('IDFIELD', idField)
    // console.log('Atributo', this.selectedAttribute)
    // console.log('ID ONDELETE', id)
    // if (!this.canDelete) {
    //   this._snackBar.open(`No tienes permisos para eliminar`, 'Cerrar', { duration: 3000 });
    //   return;
    // }

    // if (window.confirm("Esto eliminará este atributo y todas sus configuraciones")) {
    //   this.attributeService.deleteAttr({ type: this.selectedAttribute }, id).subscribe({
    //     next: () => {
    //       this.selectedItems = []
    //       this._snackBar.open('Atributo eliminado correctamente.', 'ok');
    //       this.loadData(this.selectedAttribute);
    //     },
    //     error: (err) => {
    //       console.log('Error al eliminar el producto')
    //     }
    //   })
    // }
  }
}
